import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'
const Alert = ({ variant, header, message, align = 'center' }) => {
    return (
        <div className={`trip-alert trip-alert--${variant}`}>
            <p style={{ textAlign: align }}>
                {header && <strong>{header}</strong>}
                { message }
            </p>
        </div>
    )
}

Alert.propTypes = {
    variant: PropTypes.oneOf(['danger', 'warning', 'info', 'success']),
    header: PropTypes.string,
    message: PropTypes.string.isRequired,
    align: PropTypes.oneOf(['left', 'center', 'right'])
}

export default Alert
